"use strict";

/*
 * Copyright (c) 2025 Xplat-soft s.r.o.
 *
 * This source code is licensed under the terms found in the
 * LICENSE.md file in the root directory of this source tree
 * or at https://universal-sign-in.com/license
 */

export const Color = {
  Dark: 'dark',
  Light: 'light'
};

/**
 * @group React Components
 * */

/**
 * @group React Components
 * */
//# sourceMappingURL=statics.js.map